import { StylesConfig } from 'react-select';
import { OptionType } from './DropdownSearchableClearable';

interface StyleProps {
    minWidth?: string;
    maxWidth?: string;
    width?: string;
}

export const createDropdownStyles = ({ minWidth, maxWidth, width }: StyleProps): StylesConfig<OptionType, false> => ({
    noOptionsMessage: (base) => ({
        ...base,
        textAlign: 'left',
        fontSize: '10px',
    }),
    placeholder: (base) => ({
        ...base,
        fontSize: '10px',
        padding: "0px",
        paddingBottom: "0px",
        paddingTop: "2px",
    }),
    control: (base) => ({
        ...base,
        minWidth,
        maxWidth,
        width,
        fontSize: "10px",
        padding: "0px",
        height: "32px",
        minHeight: "32px",
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 3000,
        fontFamily: `"Segoe UI", "Segoe UI Web (West European)", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif`,
        fontSize: '10px',
        fontWeight: 400,
    }),
    menu: (base) => ({
        ...base,
        width: "100%",
        minWidth: minWidth,
        maxWidth: maxWidth,
        fontSize: '10px',
        zIndex: 3000,
    }),
    singleValue: (base) => ({
        ...base,
        fontSize: '10px',
        padding: "0px",
    }),
    dropdownIndicator: (base) => ({
        ...base,
        padding: '2px',
    }),
    input: (base) => ({
        ...base,
        fontSize: "10px",
        padding: "0px",
    }),
    valueContainer: (base) => ({
        ...base,
        paddingTop: "0px",
        flex: 1,
        flexWrap: "wrap",
        position: "relative",
        paddingBottom: "4px",
    }),
});
